const HIGHLIGHT_CLASS = 'highlight';
const DEFAULT_HIGHLIGHT_DURATION_MS = 3000;

const pendingRemovals = new WeakMap<Element, ReturnType<typeof setTimeout>>();

/**
 * Points the user at an element: adds the global `.highlight` outline (`styles/global.scss`) and
 * removes it again after `durationMs`. Calling it again on the same element before that timeout
 * fires cancels the earlier one, so a second call never cuts the first highlight short.
 */
const highlight = (element: HTMLElement | null, durationMs: number = DEFAULT_HIGHLIGHT_DURATION_MS): void => {
  if (!element) {
    return;
  }

  const pendingRemoval = pendingRemovals.get(element);
  if (pendingRemoval != null) {
    clearTimeout(pendingRemoval);
  }

  element.classList.add(HIGHLIGHT_CLASS);
  pendingRemovals.set(element, setTimeout(() => {
    element.classList.remove(HIGHLIGHT_CLASS);
    pendingRemovals.delete(element);
  }, durationMs));
};

export default highlight;
